/**
 * How many users can be selected when the "Project Assignees" filter is active.
 * Each project has to be fetched with a  */
export const PROJECT_ASSIGNEES_FILTER_LIMIT = 10;

/** Key for unassigned forecast groups in groupBy operations */
export const UNASSIGNED_FORECAST_GROUP_KEY = 'UNASSIGNED';
